(function () {

	window.appSetup = {};

	window.appComponents = {
		prototypes: {},
		controllers: {},
		pageComponents: {},
		services: {},
	};

})();